import PropTypes from "prop-types";
import PubSub from "pubsub-js";
import React, { PureComponent } from "react";

import FormButton from "../../components/form/FormButton";
import SingleFormDatePicker from "../../components/form/formDatePicker/SingleFormDatePicker";
import ModalBody from "../../components/modal/ModalBody";
import ModalField from "../../components/modal/ModalField";
import ModalFooter from "../../components/modal/ModalFooter";
import ModalFooterRightGroup from "../../components/modal/ModalFooterRightGroup";
import ModalGroup from "../../components/modal/ModalGroup";
import ModalHeading from "../../components/modal/ModalHeading";
import ModalRow from "../../components/modal/ModalRow";
import ModalView from "../../components/modal/ModalView";
import PubSubTopics from "../../constants/pubSubTopics";
import dateFunctions from "../../modules/definition/calendar/dateFunctions";
import { PropTypeShapes } from "../../types";
import calendarTypes from "../../types/calendarTypes";

const isValidZeroDate = date => date && date.timestamp && date.weekday === 0;

export default class SettingsZeroDateModal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      date: props.defaultDate,
      calendar: props.calendar.set("calendarType", calendarTypes.CALENDAR_TYPE_DATE_TIME)
    };

    this.setDate = this.setDate.bind(this);
    this.onOkClick = this.onOkClick.bind(this);
    this.onUseThisWeekClick = this.onUseThisWeekClick.bind(this);
    this.onUseEarliestItemClick = this.onUseEarliestItemClick.bind(this);
  }

  componentDidMount() {
    this._pubSubEscapeKeyDownToken = PubSub.subscribe(PubSubTopics.escapeKeyDown, this.props.onCancel);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      date: nextProps.defaultDate,
      calendar: nextProps.calendar.set("calendarType", calendarTypes.CALENDAR_TYPE_DATE_TIME)
    });
  }

  componentWillUnmount() {
    PubSub.unsubscribe(this._pubSubEscapeKeyDownToken);
  }

  setDate(newDate) {
    if (newDate) {
      const useDate = dateFunctions.dateAtStartOfWeekFromDate(this.state.calendar, newDate);
      this.setState({ date: useDate });
    }
  }

  onOkClick() {
    this.props.onOk(this.state.date);
  }

  onUseThisWeekClick() {
    this.setState({ date: this.props.thisWeekDate });
  }

  onUseEarliestItemClick() {
    if (this.props.earliestItemDate) {
      this.setState({ date: this.props.earliestItemDate });
    }
  }

  render() {
    const { onCancel, earliestItemDate } = this.props;

    const labelText = "Which date should be Day 0 on your timeline?";
    let header = null;
    let footer = null;
    let groupLabel = null;

    //#!if iOS === true
// header = (
// <ModalHeading title="Change Calendar Type" showBack={true} onBackClick={this.onOkClick} showRightButton={false} />
// );
// groupLabel = labelText;
    //#!else
    header = <ModalHeading title={labelText} showCancel={false} />;
    footer = (
      <ModalFooter>
        <ModalFooterRightGroup>
          <FormButton label="Cancel" rightAlign={true} onClick={onCancel} primary={false} />
          <FormButton
            label="Ok"
            disabled={!isValidZeroDate(this.state.date)}
            rightAlign={true}
            onClick={this.onOkClick}
            primary={true}
          />
        </ModalFooterRightGroup>
      </ModalFooter>
    );
    // #!endif

    return (
      <ModalView className="confirmation changeCalendarType" header={header} footer={footer}>
        <ModalBody>
          <ModalGroup label={groupLabel}>
            <ModalRow>
              <ModalField label={`Enter ${this.state.calendar.weekdays.get(0).name} date:`}>
                <SingleFormDatePicker
                  value={this.state.date}
                  calendar={this.state.calendar}
                  onChange={this.setDate}
                  autoFocus={true}
                />
              </ModalField>
              <ModalField flex={1} label="Or choose option:">
                <div style={{ display: "flex", justifyItems: "flex-start" }} className="description">
                  <FormButton label="This week" linkStyle={true} onClick={this.onUseThisWeekClick} />
                  <FormButton
                    disabled={!earliestItemDate}
                    label="Earliest date"
                    linkStyle={true}
                    onClick={this.onUseEarliestItemClick}
                  />
                </div>
              </ModalField>
            </ModalRow>
          </ModalGroup>
        </ModalBody>
      </ModalView>
    );
  }
}

SettingsZeroDateModal.propTypes = {
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  calendar: PropTypeShapes.calendar.isRequired,
  defaultDate: PropTypeShapes.dateRecord.isRequired,
  thisWeekDate: PropTypeShapes.dateRecord.isRequired,
  earliestItemDate: PropTypeShapes.dateRecord
};
